import React from "react";
import { ArrowUpRight, MapPin, Phone, Calendar } from "lucide-react";
import { FaInstagram, FaTiktok, FaSnapchat } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from "../styles/Footer.module.css";

export default function Footer({ onBookClick }) {
  return (
    <footer className={styles.footer}>
      <div className={styles.glow} aria-hidden="true" />
      <div className={styles.shell}>
        <section className={styles.invite}>
          <div>
            <span className={styles.eyebrow}>YOUR NEXT LOOK STARTS HERE</span>
            <h2>Leave feeling<br/><em>distinctly fresh.</em></h2>
          </div>
          <div className={styles.inviteRight}>
            <p>Hair, grooming and beauty — thoughtfully delivered in Ajah, Lagos.</p>
            <button type="button" className={styles.book} onClick={onBookClick}>
              <Calendar size={17}/><span>Book an appointment</span><ArrowUpRight size={17}/>
            </button>
          </div>
        </section>

        <div className={styles.rule}><span>DF</span></div>

        <section className={styles.main}>
          <div className={styles.brand}>
            <Link to="/" aria-label="Dey Fresh Signature home">
              <img src="/assets/logo/logo.png" alt="Dey Fresh Signature" />
            </Link>
            <p>Premium unisex salon for hair, locs, barbering, nails, pedicure, lashes and facials.</p>
            <div className={styles.socials}>
              <a href="https://instagram.com/deyfreshsignature" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram/></a>
              <a href="https://tiktok.com/@deyfreshsignature" target="_blank" rel="noreferrer" aria-label="TikTok"><FaTiktok/></a>
              <a href="https://snapchat.com/t/h0hVAXuC" target="_blank" rel="noreferrer" aria-label="Snapchat"><FaSnapchat/></a>
            </div>
          </div>

          <div className={styles.column}>
            <span className={styles.label}>EXPLORE</span>
            <Link to="/">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/about">About us</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className={styles.column}>
            <span className={styles.label}>OPENING HOURS</span>
            <div className={styles.hours}><span>Mon — Sat</span><strong>9am — 8pm</strong></div>
            <div className={styles.hours}><span>Sunday</span><strong>1pm — 8pm</strong></div>
            <button type="button" className={styles.textButton} onClick={onBookClick}>Reserve your visit <ArrowUpRight size={14}/></button>
          </div>

          <div className={`${styles.column} ${styles.visit}`}>
            <span className={styles.label}>VISIT DEY FRESH</span>
            <p><MapPin size={16}/> <span>Shop H9, Ojaja Mall,<br/>Ogombo Road, Ajah, Lagos.</span></p>
            <a href="tel:+2349165387780"><Phone size={15}/> +234 916 538 7780</a>
            <a className={styles.whatsapp} href="https://wa.me/2349165387780" target="_blank" rel="noreferrer">Chat on WhatsApp <ArrowUpRight size={14}/></a>
          </div>
        </section>

        <section className={styles.bottom}>
          <span>© {new Date().getFullYear()} DEY FRESH SIGNATURE</span>
          <span className={styles.signature}>Beauty <i/> Grooming <i/> Confidence</span>
          <Link to="/contact">AJAH · LAGOS, NIGERIA</Link>
        </section>
      </div>
    </footer>
  );
}
